import { SUPPORTED_LANGUAGES } from '@/context/IntlContext.tsx';
import { updateTheme } from '@/utils/theme.ts';
import { SgwtAccountCenter } from '@sgwt/sgwt-widgets-react';
import type { JSX } from 'react';

export function AccountCenter(): JSX.Element {

  return (
    <SgwtAccountCenter
      availableLanguages={SUPPORTED_LANGUAGES}
      authentication="sg-connect"
      mode="sg-markets"
      // language={intl.locale}
      producerCode={import.meta.env.VITE_PRODUCER_CODE}
      themeSwitcher
      onThemeChanged={(event) => {
        const theme = event.themeChosen;
        updateTheme(theme);
      }}
    />
  );
}
